module.exports = __webpack_public_path__ + "static/img/chomikwr.dc5d991d.webp";